<template>
  <ContentWidth>
    <h1>Page Not Found</h1>
  </ContentWidth>
</template>

<script setup lang="ts">
import { ContentWidth } from "@saflib/vue/components";
</script>
